import React from 'react';

import type { TaskShape } from '../../types';

import { ActiveTask } from './components/ActiveTask';
import { CompletedTask } from './components/CompletedTask';

type TaskProps = TaskShape;
export function Task(props: TaskProps): React.JSX.Element | null {
	const { status, name, isFirstActive = false, ...rest } = props;

	// Don't render IGNORED tasks
	if (status === 'IGNORED') return null;

	const renderTaskContent = () => {
		// TODO: Other state tasks go here
		switch (status) {
			case 'ACTIVE': {
				// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
				return <ActiveTask name={name} isFirstActive={isFirstActive} {...rest} />;
			}
			case 'COMPLETED':
				return <CompletedTask name={name} {...rest} />;
			default:
				return null;
		}
	};

	return <div className="hover:bg-fill-inverse-weak group transition-colors duration-100">{renderTaskContent()}</div>;
}
